module.exports = __webpack_public_path__ + "img/vertical_3_2_7016.d3e300a0.png";